import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicFonctionnementTarif = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();

  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Tarification et frais', link: '/topics/paiement/tarification'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Un grand affrontement dans l'arène commence par une seule et unique demande d'inscription. Alors, comment fonctionne la tarification ? 
              Le prix total de votre inscription à un event est calculé en fonction du prix de la catégorie fixé par l'organisateur. 
              Aucun frais supplémentaire ne s'ajoutent à se montant.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                À ce jour, aucun frais supplémentaire n'est ajouté aux inscriptions des athlètes. Les frais de service sont inclus dans le 
                montant de l'inscription et sont pris en charge par Wodzone, sans coût additionnel pour l'athlète.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Votre paiement sera débité une fois validé par Stripe, qui sécurise toutes nos transactions bancaires. Cela peut être immédiat. 
                Il est possible de régler votre inscription en un seul et unique paiement. Vous recevrez une confirmation par e-mail et 
                pourrez<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>consulter les détails de tous vos paiements.</a>.
                Cliquer ensuite sur le bouton <strong>Gérer les paiement.</strong>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicFonctionnementTarif